import "./work.css";

let Work = () => {

    return (
        <div id="workSection">
            <h2 className="workTitle">Work</h2>
            <div className="container-fluid">
                <div>
                    <p className="workDescription">Currently working at <span id="homeDepot"> The Home Depot </span> I build and maintain scalable web solutions that power high-traffic digital experiences. My work spans Java-based APIs, React-driven CMS features, and analytics integrations that turn user interactions into actionable insights.</p>
                </div>

            </div>
        </div>
    )
}

export default Work;